import { datadogRum } from '@datadog/browser-rum'

export const setupDataDog = () =>
  datadogRum.init({
    applicationId: '19673eeb-f67a-42dd-862c-9a7bac0ea7d2',
    clientToken: 'pubad910c92719b7c0fdc65c80d67566486',
    site: 'datadoghq.eu',
    service: 'red-button',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    trackInteractions: true,
  })
